import ArrowRightIcon from "@/components/_icons/arrowRightIcon";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

export interface SendToKitchenButtonProps {
  merchantColor: string;
  buttonText: string;
  isButtonDisabled: boolean;
  onClick: () => void;
}

export const SendToKitchenButton = ({
  merchantColor,
  buttonText,
  isButtonDisabled,
  onClick,
}: SendToKitchenButtonProps) => {
  return (
    <button
      data-testid={applyDataTestId(pom.scanToOrder.sendToKitchenButton)}
      style={{ backgroundColor: !isButtonDisabled ? merchantColor : "#C7C7C7" }}
      className="min-h-16 text-[#fff] cursor-pointer"
      onClick={!isButtonDisabled ? onClick : () => {}}
    >
      <div className="px-[18px] flex justify-between items-center">
        <p className="text-xl font-medium">{buttonText}</p>
        <ArrowRightIcon color="#fff" height={24} width={24} />
      </div>
    </button>
  );
};
